import React from 'react';
import _ from 'lodash';

type CardDetailProps = {
  title: string;
  value: undefined | null | string | string[];
};

export const CardDetail: React.FC<CardDetailProps> = ({ title, value }) => {
  return (
    <div className="flex flex-col w-full gap-1 p-2 border rounded">
      <span className="font-semibold">{title}</span>

      {_.isEmpty(value) && <span>-</span>}

      {_.isString(value) ? (
        <pre className="text-wrap">{value}</pre>
      ) : (
        value?.map(e => (
          <span key={e} className="px-3 rounded w-fit">
            {e}
          </span>
        ))
      )}
    </div>
  );
};
